<div class="hover:cursor-pointer">
  <div class="border-2 border-offblack border-solid my-2 p-4 rounded-md" [ngClass]="{'border-danger-base':audit.AuditCompletionInfo.TotalOverdueActions>0,'border-warning-base':audit.AuditCompletionInfo.TotalOverdueActions<=0 && audit.AuditCompletionInfo.TotalOutstandingActions>0}" (click)="selectAudit()">
    <div class="flex justify-between">
      <h5 class="mr-2">{{audit.AuditName}}</h5>

      <div class="flex flex-col">
        <p class="font-bold text-right">{{formattedSubmissionDate()}}</p>
        <p class="text-right">{{audit.AuditCompletionInfo.LocationName}}</p>
      </div>

    </div>
    @if (audit.AuditInfo.ReferenceAnswer.length>0) {
      <div>
        <p>{{audit.AuditInfo.ReferenceQuestion}}: <strong>{{audit.AuditInfo.ReferenceAnswer}}</strong></p>
      </div>
    }
    <div class="mt-2">
      <p>Completed by: <strong>{{audit.AuditCompletionInfo.UserName}}</strong></p>
      <p>Outstanding Actions: <strong >{{audit.AuditCompletionInfo.TotalOutstandingActions}}</strong> @if (audit.AuditCompletionInfo.TotalOverdueActions>0) {
      <span class=""> <strong class="text-danger-base ml-2">({{audit.AuditCompletionInfo.TotalOverdueActions}} overdue)</strong> </span>
    }</p>
    @if (!audit.AuditEntryOptions.HideScore) {
      <p >Score: @if (audit.AuditCompletionInfo.MaxScore>0) {
        <strong>{{audit.AuditCompletionInfo.Score}}/{{audit.AuditCompletionInfo.MaxScore}} ({{calcPercentage()}}%)</strong>
        }@if (audit.AuditCompletionInfo.MaxScore<=0) {
        <strong >N/A</strong>
      }</p>
    }
  </div>
</div>
</div>
